import React from "react"

import ProductRatings from "components/article/product-rating"
import ContentfulButton from "components/page-components/button"
import { Container, ImageContainer, StyledImage } from "./styles"

const ProductShoppable = ({ element, backgroundImages, elRef, id, trackingId }) => {
  const { promotionalUnit } = element
  const { textAlignment, bodyText, heading, button, mediaPosition, shopifyProductVariant } =
    promotionalUnit

  const headingProps = {
    text: heading && heading.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1"),
  }

  const shopifyProduct = shopifyProductVariant?.product

  const mediaElement = (
    <ImageContainer>
      <StyledImage
        baseUrl={shopifyProduct?.media[0].image.originalSrc}
        images={[
          {
            screenSize: 1200,
            transforms: "c_fill,g_auto,w_1080,h_541,q_auto,f_auto,fl_lossy",
          },
          {
            screenSize: 992,
            transforms: "c_fill,g_auto,w_900,h_604,q_auto,f_auto,fl_lossy",
          },
          {
            screenSize: 768,
            transforms: "c_fill,g_auto,w_792,h_516,q_auto,f_auto,fl_lossy",
          },
          {
            transforms: "c_fill,g_auto,w_768,h_768,q_auto,f_auto,fl_lossy",
          },
        ]}
      />
    </ImageContainer>
  )

  return (
    <Container
      component={promotionalUnit}
      mediaPosition={textAlignment}
      heading={headingProps}
      body={bodyText && bodyText.childMarkdownRemark.html}
      review={<ProductRatings review={shopifyProduct?.review} />}
      mediaElement={mediaElement}
      reverseOrder={mediaPosition}
      preheading={headingProps}
      buttonElement={button && <ContentfulButton component={button} />}
      backgroundImages={backgroundImages}
      dataExpId={trackingId}
      elRef={elRef}
      dataId={id}
    />
  )
}

export default ProductShoppable
